import { IkeEnvironment, IkeSystem } from '@ikegps/core-api';
import { IkeConfig } from '../..';
import { OfficeAutomation } from './office.automation';
import { OfficeLocal } from './office.local';
import { OfficeProduction } from './office.production';
import { OfficeStaging } from './office.staging';
import { OfficeTest } from './office.test';
import { OfficeTest2 } from './office.test2';

export const OfficeDev = new IkeConfig(IkeSystem.OFFICE, IkeEnvironment.DEV);
OfficeDev.extend(OfficeTest);

export const OfficeConfigs: IkeConfig[] = [
	OfficeDev,
	OfficeTest,
	OfficeTest2,
	OfficeAutomation,
	OfficeStaging,
	OfficeProduction,
	OfficeLocal,
];
